import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import FormContainer from "src/components/Displays/FormContainer";
import FormSubmitContainer from "src/components/Shared/FormSubmitContainer";
import { ROUTES } from "src/consts/routes";
import { SESSION_KEYS, USER_PROFILE_DATA } from "src/consts/session";
import { useSessionStorage } from "src/hooks/useSessionStorage";
import { GlobalContextProps } from "src/components/GlobalContext/GlobalContext";
import AnnualConsumptionForm from "src/components/Forms/AnnualConsumptionForm";
import { annualGridSupplyFormSchema } from "src/schema/annualGridSupplyFormSchema";
import { useEffect } from "react";
import Text from "src/components/Displays/Text";
export interface AnnualGridSupplyFormValues {
  personsInHousehold: number;
  yearlyGridSupplyKwh: string;
}

const AnnualGridSupply = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const alertTitle = t("page.annualGridSupply.alertTitle");
  const alertDescription = t("page.annualGridSupply.alertDescription");

  const { setAnimations } = useOutletContext<GlobalContextProps>();

  const [getSessionStorageItem, setSessionStorageItem] =
    useSessionStorage<USER_PROFILE_DATA>(SESSION_KEYS.USER_PROFILE_DATA);

  const form = useForm<AnnualGridSupplyFormValues>({
    defaultValues: {
      personsInHousehold: getSessionStorageItem()?.personsInHousehold || 2,
      yearlyGridSupplyKwh:
        getSessionStorageItem()?.yearlyGridSupplyKwh || "2500",
    },
    mode: "onSubmit",
    resolver: yupResolver(annualGridSupplyFormSchema),
  });

  const handleBackClick = () => {
    navigate(ROUTES.BATTERY_SETUP);
  };

  const onSubmit = (data: AnnualGridSupplyFormValues) => {
    const sessionData = getSessionStorageItem();
    const updatedSessionData = {
      ...sessionData,
      ...data,
    };

    setSessionStorageItem(updatedSessionData);
    setAnimations((prev) => ({ ...prev, continue: !prev.continue }));
    navigate(ROUTES.SMART_METER);
  };

  useEffect(() => {
    setAnimations((prev) => ({ ...prev, People: true }));
  }, [setAnimations]);

  return (
    <FormContainer
      title={t("page.annualGridSupply.formTitle")}
      onSubmit={form.handleSubmit(onSubmit)}
    >
      <Stack sx={{ marginTop: 6, marginBottom: 3 }} gap={3}>
        <AnnualConsumptionForm form={form} />
        <Stack
          gap={1}
          padding={3}
          sx={(theme) => ({
            borderRadius: "8px",
            backgroundColor: theme.palette.grey[50],
          })}
        >
          <Text
            text={alertTitle}
            sx={{
              color: "#222",
              fontSize: "14px",
              fontWeight: 700,
              lineHeight: "18px",
            }}
          />
          <Text
            text={alertDescription}
            sx={{
              color: "#222",
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
            }}
          />
        </Stack>
      </Stack>
      <FormSubmitContainer onClick={handleBackClick} />
    </FormContainer>
  );
};

export default AnnualGridSupply;
